import { render } from "./PricingLargeScreenLayout.vue?vue&type=template&id=23830008"
import script from "./PricingLargeScreenLayout.vue?vue&type=script&lang=js"
export * from "./PricingLargeScreenLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__